import React from 'react';

// eslint-disable-next-line max-len
const PULSE_LOGO = '/themes/theme/pulse/logo.png';
const PULSE_DARK_LOGO = '/themes/theme/pulse/logo.png';

const PulseTheme = {
  headerLogo: {
    src: PULSE_LOGO,
    alt: 'Pulse Logo',
    size: 70,
  },
  darkLogo: {
    src: PULSE_DARK_LOGO,
    alt: 'Pulse Logo',
    size: 70,
  },
  linkStyle: {
    color: '#AB2923',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #AB2923',
    height: 80,
  },
  title: 'Pulse',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src={PULSE_DARK_LOGO} alt="Pulse Logo"
      />
      <br /><br />
      {/* <h3>FLYT</h3> */}
    </div>
  ),
  shareSite: 'https://share.pulse.africa',
};

export default PulseTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/pulse.js
 **/